import { atom } from 'jotai'

// 是否开始验证是否有文件存在
export const validFileExistAtom = atom<boolean>(false)
